export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./VuesticSimpleSelect.vue?vue&type=template&id=6e794a98"


//////////////////
// WEBPACK FOOTER
// ./src/vuestic-theme/vuestic-components/vuestic-simple-select/VuesticSimpleSelect.vue?vue&type=template&id=6e794a98
// module id = SWCR
// module chunks = 41